import { deleteArtColor,getArtColoresPanel,postArtColor } from "../../services/ArticulosColoresServices";
import { ArticulosColoresContext } from "./ArticulosColoresContext"

export const ArticulosColoresState = ({ children }) => {
    const getArtColoresPanelData = async (searchRam,searchTerm, page, perPage) => {
        let res = await getArtColoresPanel(searchRam,searchTerm, page, perPage)
        return res;
    }
    const deleteArtColorData = async (body) => {
        const res = await deleteArtColor(body)
        return res
    }
    const postArtColorData = async (body) => {
        const res = await postArtColor(body)
        return res
    }
    return <ArticulosColoresContext.Provider value={{
        deleteArtColorData,
        getArtColoresPanelData,
        postArtColorData
    }} >
        {children}
    </ArticulosColoresContext.Provider>
}